import cx from 'classnames';
import { ComponentProps } from 'react';

type HeaderMenuDrawerTriggerProps = ComponentProps<'button'> & {
  invert?: boolean;
  scrolled?: boolean;
  title: string;
};

export const HeaderDesktopDrawerTrigger = ({
  title,
  invert,
  scrolled,
  className,
  ...props
}: HeaderMenuDrawerTriggerProps) => (
  <button
    className={cx('block button button-size-medium', className, {
      'button-primary-link-header': !invert || scrolled,
      'button-primary-link-header-invert': invert && !scrolled,
    })}
    {...props}
  >
    {title}
  </button>
);
